import React from "react";
import Image from "react-bootstrap/Image";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";

import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
// import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import SimpleReactLightbox from "simple-react-lightbox";

export const FastFoodMenuSetupScreen = ({
  onPageChangeHandlerClosed,
  onDrop,
  onMenuSetupSubmit,
  children,
}) => {
  return (
    <React.Fragment>
      <div className="display-toggle-stepup-button">
        <RightSidePannel selectedTab={4} />
      </div>
      <div>
        <TopTextReusableComponent headingText="Menu Set up" />
        <div className="top-seating-area-heading mt-5 mb-5">
          <h4 className="big-heading-text">Upload your menu</h4>
          <p className="small-heading-text">
            (Please include all the seating areas in your food facility)
          </p>
        </div>
        <hr />
        <SimpleReactLightbox>
          {/* <MultipleImageUploadComponent
            title="Upload Menu"
            smallTitle="(You can upload the menu from restaurant in JPEG, PNG, PDF or
            Word Formats)"
            onDrop={onDrop}
            imageExtension={[".jpg", ".gif", ".png", ".jpeg"]}
          /> */}
          {children}
        </SimpleReactLightbox>
        <div className="onboarding-map-setup-screen-autodetect-button">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            onClick={onPageChangeHandlerClosed}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText="Next"
            buttonType="button"
            onClick={onMenuSetupSubmit}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FastFoodMenuSetupScreen;
